import { render, staticRenderFns } from "./backEditHelp.vue?vue&type=template&id=4eaf3f49&scoped=true"
import script from "./backEditHelp.vue?vue&type=script&lang=js"
export * from "./backEditHelp.vue?vue&type=script&lang=js"
import style0 from "./backEditHelp.vue?vue&type=style&index=0&id=4eaf3f49&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaf3f49",
  null
  
)

export default component.exports